import { isTruthy } from '@fabric-app/utils/guards';

const threeItemConfig = {
  default: [
    {
      rotate: -10,
      translate: [
        -150,
        40
      ],
      scale: 0.8
    },
    {
      rotate: 0,
      translate: [
        0,
        -60
      ],
      scale: 0.8
    },
    {
      rotate: 10,
      translate: [
        150,
        40
      ],
      scale: 0.8
    }
  ],
  hovered: [
    {
      rotate: -10,
      translate: [
        -160,
        50
      ],
      scale: 0.85
    },
    {
      rotate: 0,
      translate: [
        0,
        -70
      ],
      scale: 0.85
    },
    {
      rotate: 10,
      translate: [
        160,
        50
      ],
      scale: 0.85
    }
  ]
};
const twoItemConfig = {
  default: [
    {
      rotate: -4,
      translate: [
        -100,
        -30
      ],
      scale: 0.86
    },
    {
      rotate: 8,
      translate: [
        100,
        30
      ],
      scale: 0.86
    }
  ],
  hovered: [
    {
      rotate: -4,
      translate: [
        -110,
        -40
      ],
      scale: 0.95
    },
    {
      rotate: 8,
      translate: [
        110,
        40
      ],
      scale: 0.95
    }
  ]
};
const oneItemConfig = {
  default: [
    {}
  ],
  hovered: [
    {
      scale: 1.1
    }
  ]
};
const animationConfig = {
  1: oneItemConfig,
  2: twoItemConfig,
  3: threeItemConfig
};
const buildConfigTransformStyle = (transformConfig, options) => {
  const horizontalSpread = options.horizontalSpread || 1;
  const verticalSpread = options.verticalSpread || 1;
  return [
    transformConfig.rotate && `rotate(${transformConfig.rotate}deg)`,
    transformConfig.translate && `translate3d(${transformConfig.translate[0] * horizontalSpread}px, ${transformConfig.translate[1] * verticalSpread}px, ${options.zDepth}px)`,
    transformConfig.scale && `scale(${transformConfig.scale})`
  ].filter(isTruthy).join(" ");
};
const buildStyles = (config, options) => {
  return config[options.transitionState].map((transformConfig, index) => {
    return {
      transform: buildConfigTransformStyle(transformConfig, {
        horizontalSpread: options.horizontalSpread,
        verticalSpread: options.verticalSpread,
        zDepth: index * options.zDepth
      })
    };
  });
};
const getStyles = (options) => {
  const { listSize, transitionState, index, noTransition, horizontalSpread, verticalSpread, addDepth } = options;
  const size = Math.max(Math.min(listSize, 3), 1);
  const config = animationConfig[size];
  if (config) {
    const stylesConfig = buildStyles(config, {
      transitionState,
      horizontalSpread,
      verticalSpread,
      zDepth: addDepth ? 40 : 0
    });
    return {
      ...stylesConfig[index],
      transition: noTransition ? "none" : void 0
    };
  }
  return void 0;
};

export { getStyles };
//# sourceMappingURL=notestack.config.js.map
